import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid2";
import * as React from "react";
import { sectionSpacing } from "./section-spacing";
import { headingFontFamily } from "../heading-font";

export interface BenefitCard {
	eyebrow: string;
	icon: React.ReactElement;
	title: string;
	description: string;
	image: string;
}

export interface BenefitsContent {
	heading: string;
	subHeading: string;
	cards: BenefitCard[];
}

export function Benefits({ content: benefits }: { content: BenefitsContent }) {
	return (
		<Box
			sx={{
				bgcolor: "var(--mui-palette-neutral-100)",
				color: "var(--mui-palette-common-white)",
				overflow: "hidden",
				py: sectionSpacing,
				position: "relative",
			}}>
			<Stack
				spacing={8}
				sx={{ position: "relative", zIndex: 1 }}>
				<Container maxWidth="md">
					<Stack spacing={2}>
						<Typography
							color="text.primary"
							sx={{
								fontFamily: headingFontFamily,
								textAlign: "center",
							}}
							variant="h3">
							{benefits.heading}
						</Typography>
						<Typography
							variant="h6"
							color="text.secondary"
							sx={{ textAlign: "center" }}>
							{benefits.subHeading}
						</Typography>
					</Stack>
				</Container>
				<Container maxWidth="lg">
					{benefits.cards.map((card, index) => {
						const isEven = index % 2 === 0;

						return (
							<Grid
								alignItems="center"
								container
								key={card.eyebrow}
								spacing={3}
								sx={{ mb: index < benefits.cards.length - 1 ? 3 : 0 }}>
								{/* Text Section */}
								<Grid
									sx={{
										order: {
											xs: 1,
											md: isEven ? 0 : 1,
										},
									}}
									size={{
										md: 5,
										xs: 12,
									}}>
									<Stack spacing={2}>
										<Box
											sx={{
												display: "flex",
												justifyContent: {
													xs: "center",
													md: "flex-start",
												},
											}}>
											<Chip
												color="success"
												icon={card.icon}
												label={card.eyebrow}
												size="small"
												variant="soft"
											/>
										</Box>
										<Typography
											color="text.primary"
											sx={{
												textAlign: {
													xs: "center",
													md: "left",
												},
											}}
											variant="h5">
											{card.title}
										</Typography>
										<Typography
											color="text.secondary"
											sx={{
												textAlign: {
													xs: "center",
													md: "left",
												},
											}}>
											{card.description}
										</Typography>
									</Stack>
								</Grid>
								{/* Image Section */}
								<Grid
									sx={{
										order: {
											xs: 2,
											md: isEven ? 1 : 0,
										},
									}}
									size={{
										md: 7,
										xs: 12,
									}}>
									<Box
										sx={{
											margin: "0 auto",
											maxWidth: "100%",
											position: "relative",
											width: "390px",
										}}>
										<Box
											alt={card.title}
											component="img"
											src={card.image}
											sx={{
												height: "auto",
												position: "relative",
												width: "100%",
												zIndex: 1,
												borderRadius: "20px",
											}}
										/>
									</Box>
								</Grid>
							</Grid>
						);
					})}
				</Container>
			</Stack>
		</Box>
	);
}
